// extracted by mini-css-extract-plugin
export default {"tableBody":"tableBody--oJSXI"};